<template>
  <DxForm
    id="floorForm"
    caption="Floor Form"
  >
    <DxGroupItem
      :caption="$t('DxFloor_DxGroupItem_caption')"
      col-count="3"
    >
      <DxSimpleItem
        :data-field="$t('DxFloor_DxSimpleItem_floorSelector_dataField')"
        :editor-options="{
          items: floorOptions,
          searchEnabled: true,
          searchTimeout: searchTimeoutOption,
          minSearchLength: minSearchLengthOption,
          showDataBeforeSearch: showDataBeforeSearchOption,
          onValueChanged: floorValueChanged,
          value: initialFloor,
        }"
        editor-type="dxSelectBox"
        name="floorSelector"
      >
        <DxRequiredRule :message="$t('Required_message')" />
      </DxSimpleItem>

      <DxSimpleItem
        :data-field="$t('DxFloor_DxColumn_UsefulLife_caption')"
        name="usefulLife"
        :caption="$t('DxFloor_DxColumn_UsefulLife_caption')"
        :editor-options="{
          value: initialUsefulLife,
          showSpinButtons: true,
          placeholder: '0',
          showClearButton: true,
          min: '0',
          max: 100,
          step: '0.5',
          onValueChanged: usefulLifeChanged,
        }"
        editor-type="dxNumberBox"
      >
        <DxRequiredRule :message="$t('Required_message')" />
      </DxSimpleItem>
      <DxSimpleItem
        :data-field="$t('DxFloor_DxColumn_PercentageOfStoniness_caption')"
        name="percentageOfStoniness"
        :caption="$t('DxFloor_DxColumn_PercentageOfStoniness_caption')"
        :editor-options="{
          value: initialPercentageOfStoniness,
          showSpinButtons: true,
          placeholder: '0',
          showClearButton: true,
          min: '0',
          max: 100,
          step: '1',
          onValueChanged: percentageOfStoninessChanged,
        }"
        editor-type="dxNumberBox"
      >
        <DxRequiredRule :message="$t('Required_message')" />
      </DxSimpleItem>
    </DxGroupItem>
  </DxForm>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxRequiredRule,
} from 'devextreme-vue/form';

export default {
  name: 'DxFloor',
  components: {
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxRequiredRule,
  },
  props: {
    currentFloor: {
      type: String,
      default: '',
    },
    currentUsefulLife: {
      type: Number,
      default: 0,
    },
    currentPercentageOfStoniness: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      searchTimeoutOption: 200,
      minSearchLengthOption: 0,
      showDataBeforeSearchOption: false,
    };
  },
  computed: {
    ...mapState('Mopeco', ['floorOptions']),
  },
  beforeMount() {
    this.initialFloor = this.currentFloor;
    this.initialUsefulLife = this.currentUsefulLife;
    this.initialPercentageOfStoniness = this.currentPercentageOfStoniness;
  },
  methods: {
    floorValueChanged(e) {
      this.setCurrentFloor(e.value);
    },

    usefulLifeChanged(e) {
      this.setCurrentUsefulLife(e.value);
    },

    percentageOfStoninessChanged(e) {
      this.setCurrentPercentageOfStoniness(e.value);
    },

    ...mapActions('Mopeco', ['setCurrentFloor', 'setCurrentUsefulLife', 'setCurrentPercentageOfStoniness']),
  },
};
</script>

<style>
</style>
